'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isArray2 = require('./_internal/_isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _isArray3.default; /**
                                      * Determine if value is array
                                      *
                                      * @module isArray
                                      * @func
                                      * @since 1.0.0
                                      * @param {*} val
                                      * @return {boolean}
                                      * @example
                                      *
                                      *     isArray([]); //=> true
                                      *     isArray(1); //=> false
                                      */